/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Представление бесконечного скролла в попапах.
   */
  app.InfiniteScrollView = app.View.extend({

    /** @inheritDoc */
    run: function () {
      this.initPopup();
      var scrollableList = this.getScrollableList();
      if (scrollableList) {
        scrollableList.on('scroll', this.onListScroll.bind(this));
      }
    },

    /**
     * Инициализирует лебедевский попап.
     */
    initPopup: function () {
      this.popup = new als.Popup(this.$el);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_CLOSE,
        this.onBeforeClosePopup.bind(this)
      );
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        this.onBeforeOpenPopup.bind(this)
      );
    },

    /**
     * Скрывает затемнение перед закрытием окна.
     */
    onBeforeClosePopup: function () {
      if (app.fader) {
        app.fader.hide();
      }
      if (app.bodyView) {
        app.bodyView.toggleScrollLock(null, false);
      }
      this.trigger('close');
    },

    /**
     * Показывает затемнение перед открытием окна.
     */
    onBeforeOpenPopup: function () {
      if (app.fader) {
        app.fader.show();
      }
      if (app.bodyView) {
        app.bodyView.toggleScrollLock(null, true);
      }
      this.trigger('popup:before-open');
    },

    /**
     * Открывает или закрывает попап в зависимости от переданного аргумента.
     * @param {boolean} isOpen Определяет, открыть или закрыть попап.
     */
    toggle: function (isOpen) {
      // костыль для лебедевского попапа
      setTimeout(function () {
        if (isOpen) {
          this.popup.open();
          this.getScrollableList().scrollTop(0);
        } else {
          this.popup.close();
        }
      }.bind(this), 0);
    },

    /**
     * Обрабатывает прокрутку списка.
     */
    onListScroll: function () {
      if (this.listIsFullyScrolled()
        && this.collection.hasNextPage()
        && !this.collection.isFetching) {
        this.renderLoader();
        this.collection.isFetching = true;
        this.collection.getNextPage({
          fetch: true,
          success: function () {
            this.render(false);
            this.collection.isFetching = false;
          }.bind(this),
        });
      }
    },

    /**
     * Добавляет прелоадер.
     */
    renderLoader: function () {
      if (this.childViews.loader) {
        this.childViews.loader.render();
      } else if (app.preloader) {
        app.preloader.render();
      }
    },

    /**
     * Возвращает jQuery-элемент списка товаров для обработки событий прокрутки.
     * @returns {jQuery} jQuery-элемент списка товаров.
     */
    getScrollableList: function () {
      if (!this.$scrollableList){
        if (app.isMobile) {
          this.$scrollableList = this.$('.js-infinite-scroll-wrapper');
        } else {
          this.$scrollableList = this.$('.js-infinite-scroll-list');
        }
      }
      return this.$scrollableList;
    },

    /**
     * Возвращает булево значение, определяющее, прокручен ли список до конца.
     * @returns {boolean} Булево значение, определяющее, прокручен ли список до конца.
     */
    listIsFullyScrolled: function () {
      var listElement = this.getScrollableList().get(0);
      var threshold = 100;
      return listElement.scrollHeight - listElement.scrollTop - threshold <= listElement.clientHeight;
    },
  });
})(jQuery);

}.call(window));